import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "col-12 m-0 p-0" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-sm-6 col-12 pr-sm-0" };
const _hoisted_4 = { class: "col-sm-6 col-12" };
const _hoisted_5 = {
    key: 0,
    class: "col-12 pb-2 pb-3"
};
const _hoisted_6 = { class: "row" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("svg", {
    width: "14",
    height: "12",
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "mr-1"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M7.00016 2.66667V1.33333C7.00016 0.6 6.40016 0 5.66683 0H1.66683C0.933496 0 0.333496 0.6 0.333496 1.33333V10.6667C0.333496 11.4 0.933496 12 1.66683 12H12.3335C13.0668 12 13.6668 11.4 13.6668 10.6667V4C13.6668 3.26667 13.0668 2.66667 12.3335 2.66667H7.00016ZM3.00016 10.6667H1.66683V9.33333H3.00016V10.6667ZM3.00016 8H1.66683V6.66667H3.00016V8ZM3.00016 5.33333H1.66683V4H3.00016V5.33333ZM3.00016 2.66667H1.66683V1.33333H3.00016V2.66667ZM5.66683 10.6667H4.3335V9.33333H5.66683V10.6667ZM5.66683 8H4.3335V6.66667H5.66683V8ZM5.66683 5.33333H4.3335V4H5.66683V5.33333ZM5.66683 2.66667H4.3335V1.33333H5.66683V2.66667ZM11.6668 10.6667H7.00016V9.33333H8.3335V8H7.00016V6.66667H8.3335V5.33333H7.00016V4H11.6668C12.0335 4 12.3335 4.3 12.3335 4.66667V10C12.3335 10.3667 12.0335 10.6667 11.6668 10.6667ZM11.0002 5.33333H9.66683V6.66667H11.0002V5.33333ZM11.0002 8H9.66683V9.33333H11.0002V8Z",
        fill: "#7A7A7A"
    })
], -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", { class: "link-gray mb-0 font8-responsive" }, "Firmenname", -1);
const _hoisted_9 = [
    _hoisted_7,
    _hoisted_8
];
const _hoisted_10 = {
    key: 0,
    class: "col-12 mt-2 mb-2"
};
const _hoisted_11 = { class: "col-12 m-0 p-0" };
const _hoisted_12 = { class: "row" };
const _hoisted_13 = { class: "col-sm-8 col-12 pr-sm-0" };
const _hoisted_14 = { class: "col-sm-4 col-12" };
const _hoisted_15 = { class: "col-12" };
const _hoisted_16 = { class: "row" };
const _hoisted_17 = { class: "col-12 col-sm-3 pr-sm-0" };
const _hoisted_18 = { class: "col-12 col-sm-9" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_base_input = _resolveComponent("base-input");
    const _component_v_form = _resolveComponent("v-form");
    return (_openBlock(), _createBlock(_component_v_form, {
        onFocusout: _ctx.onFocusOutForm,
        class: "row no-gutters"
    }, {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "beforeAddressForm"),
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_base_input, {
                            id: `${_ctx.id}_first_name`,
                            name: "first_name",
                            autocomplete: "given-name",
                            placeholder: "Dein Vorname",
                            rules: _ctx.validationSchema.fields.first_name,
                            modelValue: _ctx.first_name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.first_name) = $event)),
                            onBlur: _ctx.onBlurFormField,
                            errors: _ctx.firstNameErrors
                        }, null, 8, ["id", "rules", "modelValue", "onBlur", "errors"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_base_input, {
                            id: `${_ctx.id}_last_name`,
                            name: "last_name",
                            autocomplete: "family-name",
                            placeholder: "Dein Nachname",
                            rules: _ctx.validationSchema.fields.last_name,
                            modelValue: _ctx.last_name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.last_name) = $event)),
                            onBlur: _ctx.onBlurFormField,
                            errors: _ctx.lastNameErrors
                        }, null, 8, ["id", "rules", "modelValue", "onBlur", "errors"])
                    ])
                ])
            ]),
            _renderSlot(_ctx.$slots, "beforeCompany"),
            (_ctx.withCompany)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", {
                            class: "col-12",
                            onClick: _cache[2] || (_cache[2] =
                                //@ts-ignore
                                (...args) => (_ctx.toggleShowCompany && _ctx.toggleShowCompany(...args)))
                        }, _hoisted_9),
                        (_ctx.showCompanyField)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createVNode(_component_base_input, {
                                    id: `${_ctx.id}_company`,
                                    name: "company",
                                    placeholder: "Firmenname",
                                    rules: _ctx.validationSchema.fields.company,
                                    modelValue: _ctx.company,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.company) = $event)),
                                    onBlur: _ctx.onBlurFormField,
                                    errors: _ctx.companyErrors
                                }, null, 8, ["id", "rules", "modelValue", "onBlur", "errors"])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]))
                : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "afterName"),
            _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_base_input, {
                            id: `${_ctx.id}_street_name`,
                            name: "street_name",
                            autocomplete: "address-line1",
                            placeholder: "Straße",
                            rules: _ctx.validationSchema.fields.street_name,
                            modelValue: _ctx.street_name,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.street_name) = $event)),
                            onBlur: _ctx.onBlurFormField,
                            errors: _ctx.streetNameErrors
                        }, null, 8, ["id", "rules", "modelValue", "onBlur", "errors"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_base_input, {
                            id: `${_ctx.id}_street_number`,
                            name: "street_number",
                            autocomplete: "address-line2",
                            placeholder: "Hausnummer",
                            rules: _ctx.validationSchema.fields.street_number,
                            modelValue: _ctx.street_number,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.street_number) = $event)),
                            onBlur: _ctx.onBlurFormField,
                            errors: _ctx.streetNumberErrors
                        }, null, 8, ["id", "rules", "modelValue", "onBlur", "errors"])
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_base_input, {
                            id: `${_ctx.id}_postcode`,
                            name: "postcode",
                            autocomplete: "postal-code",
                            placeholder: "PLZ",
                            rules: _ctx.validationSchema.fields.postcode,
                            modelValue: _ctx.postcode,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.postcode) = $event)),
                            onBlur: _ctx.onBlurFormField,
                            errors: _ctx.postCodeErrors
                        }, null, 8, ["id", "rules", "modelValue", "onBlur", "errors"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_base_input, {
                            id: `${_ctx.id}_city`,
                            name: "city",
                            autocomplete: "address-level2",
                            placeholder: "Ort",
                            rules: _ctx.validationSchema.fields.city,
                            modelValue: _ctx.city,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.city) = $event)),
                            onBlur: _ctx.onBlurFormField,
                            errors: _ctx.cityErrors
                        }, null, 8, ["id", "rules", "modelValue", "onBlur", "errors"])
                    ])
                ])
            ]),
            _renderSlot(_ctx.$slots, "afterAddressForm")
        ]),
        _: 3
    }, 8, ["onFocusout"]));
}
